import React from 'react'
import { injectIntl, } from 'react-intl'

import Button from '../button/Button'
import DatePickerContainer from '../datePickerContainer/DatePickerContainer'
import Link from '../link/Link'

// import classNames from 'classnames'

const DataRangeSelector = ({
  intl, classColDatePicker, dateFrom, dateTo, minDateFrom, maxDateFrom, minDateTo, maxDateTo, onChangeDateFrom, onChangeDateTo,
  applyCallback, cancelCallback, hideApplyBtn
}) => {
  const propDateFrom = {
    fieldValue: dateFrom,
    locale: intl.locale,
    callback: onChangeDateFrom,
    dateFormat: 'yyyy-MM-dd',
    isClearable: false,
    // className: 'test-statistics-DateFromSelector',
    minDate: minDateFrom,
    maxDate: maxDateFrom
  }

  const propDateTo = {
    fieldValue: dateTo,
    locale: intl.locale,
    callback: onChangeDateTo,
    dateFormat: 'yyyy-MM-dd',
    isClearable: false,
    // className: 'yyyy-MM-dd',
    minDate: minDateTo,
    maxDate: maxDateTo

  }

  const propApplyBtn = {
    children: intl.formatMessage({ id: 'Load.Common.Apply' }),
    kind: 'secondary',
    onClick: onClickApply,
    disabled: !dateFrom || !dateTo

  }

  function onClickApply() {
    applyCallback(dateFrom, dateFrom)
  }

  return (
    <>
      <div className={classColDatePicker}>
        <DatePickerContainer {...propDateFrom} />
      </div>
      <div>
        <strong className='frontend-p-right-x-sm'>{intl.formatMessage({ id: 'Load.MailupCommon.ToDate' }).toLowerCase()}</strong>
      </div>

      <div className={classColDatePicker}>
        <DatePickerContainer {...propDateTo} />
      </div>
      {!hideApplyBtn && <Button {...propApplyBtn} />}
      <Link className='frontend-link-secondary frontend-p-left-x-sm' onClick={cancelCallback}>{intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}</Link>
    </>
  )
}

DataRangeSelector.defaultProps = {
  classColDatePicker: 'col-flex-2 p-left-0'
}


export default injectIntl(DataRangeSelector)
